import React from "react";
import { Header, Footer, ReferenceLogos ,EasyStart} from "../../containers";
import { MetaTags,HeroSection,EarnMoney } from "../../components";
const Home = () => {
  return (
    <>
     

      <MetaTags title={"Galata Anket"} />
      <Header isTransparent={true} />
      <HeroSection/>
      <EasyStart/>
      <EarnMoney/>
   
      <br />
      <br />
      <br />
      <br />
      <br />

      <ReferenceLogos />
      <Footer />
    </>
  );
};

export default Home;
